import React from 'react';
import styled from 'styled-components';
import { Title } from '../../UI/Typography';
import { Container } from '../../UI/Containers';
import { useEffect, useState } from 'react';
import attendanceService from '../../../Services/Api/attendanceService';
import CorrectionsTable from '../Attendancecomponents/CorrectionsTable';

const PageContainer = styled(Container)`
  padding: ${({ theme }) => theme.spacing.lg};
  background-color: ${({ theme }) => theme.colors.background};
  max-width: 1200px;
  margin: 0 auto;
`;

function Corrections() {
  const [corrections, setCorrections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const res = await attendanceService.getAttendanceCorrections();
      setCorrections(res);
    } catch (e) {
      setError(e.message || 'Failed to load');
    } finally { setLoading(false); }
  };

  const handleUpdate = async (id, payload) => {
    try {
      await attendanceService.updateAttendanceCorrection(id, payload);
      // refresh list
      await load();
    } catch (e) {
      setError(e.message || 'Update failed');
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <PageContainer>
      <Title>Attendance Corrections</Title>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {!loading && !error && (
        <CorrectionsTable corrections={corrections} onUpdate={handleUpdate} />
      )}
    </PageContainer>
  );
}

export default Corrections;
